import type { CelebrationItem } from "../../../../hooks/use-celebrations.ts";

function anniversaryTodayTitle(yearsCompleted: number | null): string {
  if (yearsCompleted === 1) return "1 Year at Caelius";
  if (yearsCompleted != null) {
    return `${yearsCompleted} Years at Caelius`;
  }
  return "Work Anniversary";
}

export function getCelebrationCardTitle(item: CelebrationItem): string {
  if (item.type === "BIRTHDAY") {
    return item.bucket === "today" ? "Birthday Today" : "Upcoming Birthday";
  }
  if (item.bucket === "upcoming") {
    return "Upcoming Work Anniversary";
  }
  return anniversaryTodayTitle(item.yearsCompleted);
}
